import { Navigate, Outlet, useLocation, useOutletContext, useParams } from 'react-router-dom'

import Loading from '@hapana/shared/web/components/shared/loading/loading.component'
import useAuthStore from '_stores/auth.store'
import { usePermissions } from '_stores/permissions.store'

const RequireAuth = () => {
  const location = useLocation()
  const params = useParams()
  const isQuickSearch = useOutletContext()
  const permissionsStore = usePermissions()

  const { user, idToken, loading, initialized, headersReady } = useAuthStore()
  const hasValidSession = !!user && !!idToken

  const isLoading = loading || !initialized || (initialized && !headersReady)

  if (isLoading) {
    return <Loading />
  }

  if (!hasValidSession) {
    // Demo users: Firebase auth may still be resolving after tenant switch
    // (onIdTokenChanged briefly fires with null during tenant init).
    // If the demo-authenticated flag is set, keep showing loading instead of redirecting.
    const hasDemoSession = sessionStorage.getItem('demo-authenticated') === 'true'
    if (hasDemoSession) {
      return <Loading />
    }

    const { corporateSlug } = params
    const loginPath = corporateSlug ? `/${corporateSlug}/login` : '/login'
    return <Navigate to={loginPath} state={{ from: location }} replace />
  }

  return !isQuickSearch ? <Outlet context={{ ...permissionsStore, isQuickSearch }} /> : <Loading />
}

RequireAuth.propTypes = {}

export default RequireAuth
